
<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h2>Manage Service Accounts</h2>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="table-card">
        <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" [href]="'/#/edit-service-account'">Create Service Account</a></list-controls>
        <table class="table table-responsive">
          <thead>
            <tr class="table-header-with-controls">
              <th>Service Key</th>
              <th>Organization</th>
              <th>Updated</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let serviceAccount of serviceAccounts">
              <td>{{ serviceAccount.uid }}</td>
              <td>{{ serviceAccount.organization }}</td>
              <td>{{ serviceAccount.updatedAt }}</td>
              <td><a href="#/edit-service-account?id={{ serviceAccount.id }}"><span class="oi oi-pencil"></span><span> Edit</span></a></td>
              <td>
                <div class="btn-group float-right">
                  <div class="dropdown">
                    <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">Manage Tokens</button>
                    <div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="javascript:void(0)" (click)="resetIncomingToken(serviceAccount.id, serviceAccount.uid)">Reset Incoming Token</a><a class="dropdown-item" href="javascript:void(0)" (click)="useIncomingAsOutgoingToken(serviceAccount.id)">Use Incoming Token as Outgoing Token</a><a class="dropdown-item" href="javascript:void(0)" (click)="resetOutgoingToken(serviceAccount.id, serviceAccount.uid)">Reset Outgoing Token</a><a class="dropdown-item" href="javascript:void(0)" (click)="updateOutgoingToken(serviceAccount.id)">Change Outgoing Token</a></div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="serviceAccounts.length === 0">
              <td colspan="6">
                <p class="text-center empty-table-message">There are no Service Accounts to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>